export default __webpack_public_path__ + "static/media/business-25a.62a20451.jpg";